module.exports = __webpack_public_path__ + "img/clod-close.95f209fb.svg";